import { render, staticRenderFns } from "./PTabs.vue?vue&type=template&id=2aec163b&"
import script from "./PTabs.vue?vue&type=script&lang=js&"
export * from "./PTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports